// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartTableRowStyle_name__Lpqqb {
  font-weight: bold;
  font-size: 1rem;
}

.cartTableRowStyle_configuration__2ilmx {
  font-size: 1rem;
}

.cartTableRowStyle_leadtime__9WoIK {
  font-style: italic;
  font-size: 0.9rem;
}

.cartTableRowStyle_price__clzmR {
  font-weight: bold;
  font-size: 1rem;
}

.cartTableRowStyle_unitPrice__tKT9E {
  font-size: 0.9rem;
  font-style: italic;
}

.cartTableRowStyle_previewImage__c2xhv {
  height: 72px;
  width: 108px;
  display: inline-block;
  background-color: #ccc;
}

.cartTableRowStyle_cellsNoWrap__W5M9b {
  white-space: nowrap;
}

.cartTableRowStyle_cellItemDescription__w8GUr {
  width: 60%;
}

@media screen and (max-width: 1000px) {
  .cartTableRowStyle_name__Lpqqb,
  .cartTableRowStyle_configuration__2ilmx,
  .cartTableRowStyle_price__clzmR {
    font-size: 0.8rem;
  }

  .cartTableRowStyle_leadtime__9WoIK,
  .cartTableRowStyle_unitPrice__tKT9E {
    font-size: 0.7rem;
  }

  .cartTableRowStyle_previewImage__c2xhv {
    height: 36px;
    width: 54px;
  }
}

.cartTableRowStyle_modalHeader__MyCqq {
  color: var(--black);
  font-weight: bold;
  margin-bottom: -5px;
  padding-left: 1rem;
  opacity: 0.8;
  text-transform: uppercase;
}

.cartTableRowStyle_pd__KGqeb {
  padding: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Styles/cartTableRowStyle.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".name {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.configuration {\n  font-size: 1rem;\n}\n\n.leadtime {\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\n.price {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.unitPrice {\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.previewImage {\n  height: 72px;\n  width: 108px;\n  display: inline-block;\n  background-color: #ccc;\n}\n\n.cellsNoWrap {\n  white-space: nowrap;\n}\n\n.cellItemDescription {\n  width: 60%;\n}\n\n@media screen and (max-width: 1000px) {\n  .name,\n  .configuration,\n  .price {\n    font-size: 0.8rem;\n  }\n\n  .leadtime,\n  .unitPrice {\n    font-size: 0.7rem;\n  }\n\n  .previewImage {\n    height: 36px;\n    width: 54px;\n  }\n}\n\n.modalHeader {\n  color: var(--black);\n  font-weight: bold;\n  margin-bottom: -5px;\n  padding-left: 1rem;\n  opacity: 0.8;\n  text-transform: uppercase;\n}\n\n.pd {\n  padding: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `cartTableRowStyle_name__Lpqqb`,
	"configuration": `cartTableRowStyle_configuration__2ilmx`,
	"leadtime": `cartTableRowStyle_leadtime__9WoIK`,
	"price": `cartTableRowStyle_price__clzmR`,
	"unitPrice": `cartTableRowStyle_unitPrice__tKT9E`,
	"previewImage": `cartTableRowStyle_previewImage__c2xhv`,
	"cellsNoWrap": `cartTableRowStyle_cellsNoWrap__W5M9b`,
	"cellItemDescription": `cartTableRowStyle_cellItemDescription__w8GUr`,
	"modalHeader": `cartTableRowStyle_modalHeader__MyCqq`,
	"pd": `cartTableRowStyle_pd__KGqeb`
};
export default ___CSS_LOADER_EXPORT___;
